<template>
  <template v-if="fileHandler.uploadStatus.value.status === 'waiting'">
    <slot name="waiting">
      <div
        class="flex animate-pulse items-center gap-4 rounded-md bg-neutral-100 px-4 py-2 text-neutral-800"
      >
        <div>
          <TIcon size="48" name="upload" />
        </div>
      </div>
    </slot>
  </template>

  <template v-if="fileHandler.uploadStatus.value.status === 'uploading'">
    <slot name="uploading" :status="fileHandler.uploadStatus.value">
      <div
        class="flex animate-pulse items-center gap-4 rounded-md bg-neutral-100 px-4 py-2 text-neutral-800"
      >
        <div>
          <TIcon size="48" name="upload" />
        </div>
        <div class="grow">
          <div class="">{{ fileHandler.uploadStatus.value.file.name }}</div>
          <TProgress
            :percent="fileHandler.uploadStatus.value.progressPercent"
          />
        </div>
        <div v-if="props.showCancel">
          <IconButton
            size="sm"
            variant="ghost-primary"
            icon="cancel"
            @click="emit('cancel')"
          />
        </div>
      </div>
    </slot>
  </template>

  <template v-if="fileHandler.uploadStatus.value.status === 'done'">
    <slot name="done" :status="fileHandler.uploadStatus.value">
      <TFilePreview
        :file-handler="fileHandler"
        :upload="fileHandler.uploadStatus.value.upload"
      />
    </slot>
  </template>

  <template v-if="fileHandler.uploadStatus.value.status === 'error'">
    <slot name="error">
      <div
        class="bg-danger-50 text-danger-800 flex items-center gap-4 rounded-md px-4 py-2"
      >
        <div>
          <TIcon size="48" name="warning" />
        </div>
        <div class="grow">
          <div class="font-bold">
            {{ fileHandler.uploadStatus.value.file.name }}
          </div>
          <span class="">{{ $t('library.file_upload.error') }}</span>
        </div>
      </div>
    </slot>
  </template>
</template>
<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
import TIcon from '../Icon/TIcon.vue';
import TProgress from '../TProgress.vue';
import TFilePreview from './TFilePreview.vue';
import { FileHandler } from './file-handler';
import IconButton from '../IconButton/IconButton.vue';

const props = withDefaults(
  defineProps<{
    fileHandler: FileHandler;
    showCancel?: boolean;
  }>(),
  {
    showCancel: false,
  },
);

const emit = defineEmits<{
  cancel: [];
}>();
</script>
